import { config, zSpaceConfig } from '../config';
import { Object3D, Vector3 } from 'three';
import { ParentEvent, ResourcesManager, ScenarioProcessor, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import TasksProgress from '../components/TasksProgress';
import TaskScreen from '../components/TaskScreen';
import WelcomeScreen from '../components/WelcomeScreen';
import LobbyScreen from '../components/LobbyScreen';
import PipetteHolderModule from './MicropipetteModules/PipetteHolderModule';
import PipetteModule from './MicropipetteModules/PipetteModule';
import TestTubeHolderModule from './MicropipetteModules/TestTubeHolderModule';
import TipsHolderModule from './MicropipetteModules/TipsHolderModule';
import TrashCanModule from './MicropipetteModules/TrashCanModule';
import FocusHolderModule from './MicropipetteModules/FocusHolderModule';
import { MaterialImprovement } from '../utils/MaterialImprovement';
export default class MicropipetteLevel extends ViewerModule {
    constructor(levelNumber, title, lobby) {
        super();
        this.lobby = lobby;
        this.__inited = false;
        this.cameraPositionVR = new Vector3(-19.691, -15.6, -2.833);
        this.wrapScreenPosition = new Vector3(-3.52, 1.54, -5.15);
        this.levelFinished = false;
        this._interaction = false;
        this.viewerConf = config;
        this.pointerController = Viewer.pointerController;
        this.pointerController.uiObject.name = 'pointerController';
        this.cameraPosition = new Vector3(-19.691, -13.5977, -2.833);
        this.cameraTargetNormal = new Vector3(-19.696, -13.6, -2.842);
        this.uiObject.name = 'MICROPIPETTE LEVEL';
        this.table = ResourcesManager.getModel('micropipette_table').clone();
        this.table.name = 'TABLE';
        this.zSpacePositions = zSpaceConfig.micropipette;
        this.table.position.set(0, -7, 0);
        this.addObject(this.table);
        this.initInstruments();
        this.addUI();
        this.addLobbyUI(levelNumber, title);
        this.initScenario();
        // this.initZSpaceSettings();
    }
    initZSpaceSettings() {
        Viewer.on('goToZSpace', () => {
            console.log('goToZSpace--------');
            setTimeout(() => {
                if (this.instruments.pipette.uiObject.userData.zsScale)
                    this.instruments.pipette.uiObject.scale.setScalar(this.instruments.pipette.uiObject.userData.zsScale);
                if (this.instruments.pipette.uiObject.userData.zsParent) {
                    this.instruments.pipette.uiObject.userData.zsParent.add(this.instruments.pipette.uiObject);
                    this.instruments.pipette.sliderPistonComponent.uiObject.userData.zsParent.add(this.instruments.pipette.sliderPistonComponent.uiObject);
                    this.instruments.pipette.sliderPistonComponent.uiObject.position.copy(this.instruments.pipette.sliderPistonComponent.uiObject.userData.zsPosition);
                    this.instruments.pipette.sliderPistonComponent.uiObject.scale.setScalar(this.instruments.pipette.sliderPistonComponent.uiObject.userData.zsScale);
                }
            }, 150);
        });
        Viewer.on('goFromZSpace', () => {
            console.log('goFromZSpace::::::::');
            setTimeout(() => {
                if (this.instruments.pipette.uiObject.userData.pcScale)
                    this.instruments.pipette.uiObject.scale.setScalar(this.instruments.pipette.uiObject.userData.pcScale);
                if (this.instruments.pipette.uiObject.userData.pcParent) {
                    this.instruments.pipette.uiObject.userData.pcParent.add(this.instruments.pipette.uiObject);
                    this.instruments.pipette.sliderPistonComponent.uiObject.userData.pcParent.add(this.instruments.pipette.sliderPistonComponent.uiObject);
                    this.instruments.pipette.sliderPistonComponent.uiObject.position.copy(this.instruments.pipette.sliderPistonComponent.uiObject.userData.pcPosition);
                    this.instruments.pipette.sliderPistonComponent.uiObject.scale.setScalar(this.instruments.pipette.sliderPistonComponent.uiObject.userData.pcScale);
                }
            }, 150);
        });
    }
    get interaction() {
        return this._interaction;
    }
    set interaction(value) {
        this._interaction = value;
        console.log('Micropipette LEVEL INTERACTION = ', this._interaction);
    }
    initInstruments() {
        this.instrumentsPositions = {
            pipetteHolder: new Vector3(-2.67, 4.77, -.70),
            pipette: new Vector3(0, 0, 0),
            testTubeHolder: new Vector3(2.25, 3.57, -.41),
            tipsHolder: new Vector3(-3.28, 3.32, 1.3),
            trashCan: new Vector3(4.4, 3.88, -2.25),
            focusHolder: new Vector3(0, 3.58, 1.92),
        };
        this.instruments = {
            pipetteHolder: new PipetteHolderModule(this),
            pipette: new PipetteModule(this),
            testTubeHolder: new TestTubeHolderModule(this),
            tipsHolder: new TipsHolderModule(this),
            trashCan: new TrashCanModule(this),
            focusHolder: new FocusHolderModule(this),
        };
        for (let instrumentsKey in this.instruments) {
            this.table.add(this.instruments[instrumentsKey].uiObject);
            this.instruments[instrumentsKey].uiObject.position.copy(this.instrumentsPositions[instrumentsKey]);
        }
        this.instruments.pipette.once('not_full', (event) => {
            this.welcomeScreen.init('Experiment failed!', event.data.tooMuch ? 'Too much volume selected.' : 'Not enough volume selected.', 'Back to Lobby', 'Try Again!');
        });
    }
    addUI() {
        this.uiContainer = new Object3D();
        this.uiContainer.name = 'uiContainer';
        this.uiContainer.visible = false;
        this.addObject(this.uiContainer);
        this.addObject(this.uiContainerObjects = new Object3D());
        this.uiContainerObjects.name = 'uiContainerObjects';
        this.tasksProgress = new TasksProgress();
        this.tasksProgress.uiObject.position.set(0, 3.3, -5);
        this.tasksProgress.uiObject.name = 'Task PROGRESS';
        this.uiContainer.add(this.tasksProgress.uiObject);
        this.taskScreen = new TaskScreen();
        this.taskScreen.uiObject.position.set(0, 0, -5);
        this.taskScreen.uiObject.name = 'Task SCREEN';
        this.uiContainer.add(this.taskScreen.uiObject);
        this.welcomeScreen = new WelcomeScreen();
        this.welcomeScreen.uiObject.position.set(0, .5, 1);
        this.welcomeScreen.uiObject.name = 'WELCOME_POP_UP';
        this.welcomeScreen.uiObject.visible = false;
        this.uiContainer.add(this.welcomeScreen.uiObject);
        this.welcomeScreen.init('Experiment finished!', 'You have successfully accomplished the experiment.', 'Back to Lobby');
        this.welcomeScreen.on('ok', () => {
            this.interaction = false;
            // @ts-ignore
            if (!this.welcomeScreen.secondButton.uiObject.parent)
                this.levelFinished = true;
            if (this.levelFinished) {
                if (this.taskScreen && this.tasksProgress) {
                    this.removeObject(this.taskScreen);
                    this.removeObject(this.tasksProgress);
                }
                this.title.setProgress('9/9');
            }
            this.fire('exit', new ParentEvent('exit'));
        });
        this.welcomeScreen.on('secondButtonClick', () => {
            this.welcomeScreen.uiObject.visible = false;
            this.restart();
            this.interaction = true;
        });
        // this.instruments.pipette.once('not_full', (event) => {
        //     this.welcomeScreen.init('Experiment failed!', event.data.tooMuch ? 'Too much volume selected.' : 'Not enough volume selected.', 'Back to Lobby', 'Try Again!');
        // });
    }
    addLobbyUI(levelNumber, title) {
        let lobbyUI = new Object3D();
        lobbyUI.name = 'LOBBY UI';
        this.addObject(lobbyUI);
        this.title = new LobbyScreen();
        this.title.init('Level ' + levelNumber, title, '0/9');
        lobbyUI.add(this.title.uiObject);
        this.title.uiObject.position.y = 10;
        this.title.on('start', () => {
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.fire('start', new ParentEvent('start'));
        });
        this.on('started', () => {
            // @ts-ignore
            if (this.welcomeScreen.uiObject.visible !== 'true')
                this.interaction = true;
        });
        this.title.on('tutorial', () => this.fire('tutorial'));
    }
    initScenario() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        MaterialImprovement.upgradeMaterialsFromModel(this.table, this.uiObject.name);
        this.scenario = {
            name: 'scenarioName',
            modules: [
                { name: 'tasksProgress', instance: this.tasksProgress },
                { name: 'taskScreen', instance: this.taskScreen },
                { name: 'welcomeScreen', instance: this.welcomeScreen },
                { name: 'lobbyScreen', instance: this.title },
                { name: 'pipetteHolder', instance: this.instruments.pipetteHolder },
                { name: 'pipette', instance: this.instruments.pipette },
                { name: 'tipsHolder', instance: this.instruments.tipsHolder },
                { name: 'testTubeHolder', instance: this.instruments.testTubeHolder },
                { name: 'focusHolder', instance: this.instruments.focusHolder },
                { name: 'trashCan', instance: this.instruments.trashCan },
            ],
            steps: [
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 0],
                        ['focusHolder', 'init'],
                        ['testTubeHolder', 'init'],
                        ['pipette', 'init'],
                        ['pipetteHolder', 'createClickEvent'],
                        ['pipetteHolder', 'returnToHolder'],
                        [
                            'taskScreen', 'init', 'Task 1',
                            'Select Micropipette.',
                            `Click ${((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled) ? 'and hold' : ''} on the micropipette to pick it up.`,
                            '1.4'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipetteHolder.once('holder_clicked', resolve);
                    }),
                    onAfter: [
                        ['pipette', 'addToPointer'],
                        ['lobbyScreen', 'setProgress', '1/9']
                    ]
                }, {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 1],
                        ['tipsHolder', 'initPicking'],
                        [
                            'taskScreen', 'init', 'Task 2',
                            'Apply the tip.',
                            `${((_b = Viewer.zSpace) === null || _b === void 0 ? void 0 : _b.enabled) ? 'Drag' : 'Click'} on the tip holder to apply the tip.`,
                            '1.4'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.tipsHolder.once('holder_clicked', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'applyTip'],
                        ['tipsHolder', 'setTipVisibility', false],
                        ['lobbyScreen', 'setProgress', '2/9']
                    ]
                }, {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('tip_applied', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [['pipette', 'initAdjusting']]
                }, {
                    onBefore: [['tasksProgress', 'init', 9, 2]],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('ready_to_adjust', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'initSlider'],
                        ['lobbyScreen', 'setProgress', '2/9']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 2],
                        [
                            'taskScreen', 'init', 'Task 3',
                            `Adjust Micropipette Volume to 100 microliters.`,
                            ((_c = Viewer.zSpace) === null || _c === void 0 ? void 0 : _c.enabled)
                                ? 'Press the Left or Right buttons on stylus to adjust the volume. Display on the pipette should say `100`.'
                                : 'Move the slider on the volume regulator at the top of the micropipette to adjust the volume. Display on the pipette should say `100`.',
                            .8
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('adjustment_completed', resolve);
                    }),
                    onError: [['module1', 'setText', '1 step onError']],
                    onAfter: [['lobbyScreen', 'setProgress', '3/9']]
                },
                {
                    onBefore: [
                        ['pipette', 'addToPointer'],
                        ['focusHolder', 'createClickEvent'],
                        ['tasksProgress', 'init', 9, 3],
                        [
                            'taskScreen', 'init', 'Task 4',
                            'Fill Micropipette.',
                            ((_d = Viewer.zSpace) === null || _d === void 0 ? void 0 : _d.enabled) ? 'Drag it to the red tube.' : 'Click on the red tube.',
                            '1.3'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.focusHolder.once('holder_clicked', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'initFilling'],
                        ['lobbyScreen', 'setProgress', '4/9']
                    ]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('ready_to_fill', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [['pipette', 'animateButton']]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 4],
                        [
                            'taskScreen', 'init', 'Task 5',
                            'Fill Micropipette.',
                            ((_e = Viewer.zSpace) === null || _e === void 0 ? void 0 : _e.enabled) ? 'Press the Left button on stylus to fill the micropipette.' : 'Drag the slider to fill the micropipette.',
                            '1.3'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('pipette_button_clicked', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['focusHolder', 'setEmptyTube'],
                        ['lobbyScreen', 'setProgress', '5/9']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 5],
                        [
                            'taskScreen', 'init', 'Task 6',
                            'Empty liquid into an empty test tube.',
                            ((_f = Viewer.zSpace) === null || _f === void 0 ? void 0 : _f.enabled) ? 'Press and hold the pipette.' : 'Click on the pipette and then on the test tubes stand.',
                            1.1
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        resolve();
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'addToPointer'],
                        ['testTubeHolder', 'createClickEvent']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 5],
                        [
                            'taskScreen', 'init', 'Task 6',
                            'Empty liquid into an empty test tube.',
                            ((_g = Viewer.zSpace) === null || _g === void 0 ? void 0 : _g.enabled) ? 'Drag the pipette to the test tubes stand.' : 'Click on the test tubes stand.',
                            1.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.testTubeHolder.once('holder_clicked', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'initDevastation'],
                        ['lobbyScreen', 'setProgress', '6/9']
                    ]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('ready_to_devastate', resolve);
                    }),
                    onAfter: [['pipette', 'animateButton']]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 6],
                        [
                            'taskScreen', 'init', 'Task 7',
                            'Empty liquid into an empty test tube.',
                            ((_h = Viewer.zSpace) === null || _h === void 0 ? void 0 : _h.enabled) ? 'Press the Left button on stylus to empty the micropipette.' : 'Now use slider to empty the micropipette.',
                            1.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('pipette_button_clicked', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['testTubeHolder', 'setEmptyTube'],
                        ['lobbyScreen', 'setProgress', '7/9']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 6],
                        [
                            'taskScreen', 'init', 'Task 7',
                            'Throw Out Tip.',
                            ((_j = Viewer.zSpace) === null || _j === void 0 ? void 0 : _j.enabled)
                                ? 'Finally, you will need to throw out the tip into the trashcan. Press and hold the micropipette and then drag to the trash can to throw away the micropipette tip.'
                                : 'Finally, you will need to throw out the tip into the trashcan. Click on the micropipette and then drag to the trash can to throw away the micropipette tip.',
                            0.9
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        resolve();
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'addToPointer'],
                        ['trashCan', 'createClickEvent'],
                        ['lobbyScreen', 'setProgress', '7/9']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 7],
                        [
                            'taskScreen', 'init', 'Task 8',
                            'Throw Out Tip.',
                            ((_k = Viewer.zSpace) === null || _k === void 0 ? void 0 : _k.enabled)
                                ? 'Release the button over on the trash can to throw away the micropipette tip.'
                                : 'Click on the trash can to throw away the micropipette tip.',
                            '1.1'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.trashCan.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initTrashTip']]
                }, {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('tip_trashed', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['pipette', 'setTipVisibility', false],
                        ['lobbyScreen', 'setProgress', '8/9']
                    ]
                },
                {
                    onBefore: [
                        ['pipette', 'addToPointer'],
                        ['pipetteHolder', 'createClickEvent', true],
                        ['tasksProgress', 'init', 9, 8],
                        [
                            'taskScreen', 'init', 'Task 9',
                            'Put the pipette back.',
                            ((_l = Viewer.zSpace) === null || _l === void 0 ? void 0 : _l.enabled)
                                ? 'Release the micropipette on pipette stand to put it back.'
                                : 'Click on the pipette stand to put it back.',
                            '1.4'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipetteHolder.once('holder_clicked', () => {
                            this.interaction = false;
                            resolve();
                        });
                    }),
                    onAfter: [
                        ['pipette', 'addToHolder'],
                        ['tasksProgress', 'init', 9, 9],
                        ['welcomeScreen', 'show', 'true'],
                        ['lobbyScreen', 'setProgress', '9/9']
                    ]
                },
            ]
        };
        this.scenarioProcessor = new ScenarioProcessor(this.scenario);
        this.scenarioProcessor.init();
    }
    showInfo(isShow = true) {
        this.title.uiObject.visible = isShow;
        this.uiContainer.visible = !isShow;
    }
    hideAllInfo() {
        // this.uiContainer.visible = this.uiContainerObjects.visible = this.title.uiObject.visible = false;
        this.uiContainer.visible = this.title.uiObject.visible = false;
    }
    restart() {
        var _a;
        this.title.setProgress('0/9');
        this.pointerController.setObject(null);
        this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject && this.lobby.app.zSpacePickingController.forceRelease();
        this.table.traverse(el => {
            if (this.lobby.app.zSpacePickingController)
                this.lobby.app.zSpacePickingController.off(null, el);
        });
        for (let index in this.scenario.modules) {
            const module = this.scenario.modules[index];
            // @ts-ignore
            if (index > 3)
                module.instance.dispose(); // DOES NOT WORK SOMEHOW
        }
        this.interaction = false;
        this.initInstruments();
        console.warn(Viewer.controls.zController, (_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled);
        this.initScenario();
        this.welcomeScreen.init('Experiment finished!', 'You have successfully accomplished the experiment.', 'Back to Lobby');
        this.welcomeScreen.uiObject.visible = false;
    }
    update() {
    }
}
